@if (isMobile()) {
  <button mat-icon-button aria-label="Notifications" (click)="openNotifications()">
    <ng-container *ngTemplateOutlet="badge"></ng-container>
    <mat-icon>notifications</mat-icon>
  </button>
} @else if (useNewTopBar()) {
  <button mat-icon-button aria-label="Notifications" cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="open()">
    <ng-container *ngTemplateOutlet="badge"></ng-container>
    <mat-icon>notifications</mat-icon>
  </button>
  <ng-template
    #notificationsOverlay
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayOpen]="(open$$ | async) === true"
    [cdkConnectedOverlayGrowAfterOpen]="true"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    (backdropClick)="close()"
    >
    <ng-container *ngTemplateOutlet="flyout"></ng-container>
  </ng-template>
} @else {
  <atlas-item icon="notifications" [badgeContent]="unviewed$ | async" interactable ariaLabel="Notifications">
    <atlas-menu id="atlas-navbar__notifications" (onOpen)="open()" (onClose)="close()">
      <ng-container *ngTemplateOutlet="flyout"></ng-container>
    </atlas-menu>
  </atlas-item>
}

<ng-template #badge>
  @if (unviewed$ | async; as unviewed) {
    @if (unviewed) {
      <glxy-badge [color]="'red-solid'" [size]="'small'" class="atlas-navbar__item__badge">
        {{ unviewed }}
      </glxy-badge>
    }
  }
</ng-template>

<ng-template #flyout>
  <atlas-flyout (markAllAsFollowed)="markAllAsFollowed()" (closed)="isMobile() ? closeNotificationsModal() : close()">
    @if (notificationsBuffer$$ | async; as notifications) {
      @if (notifications?.length === 0) {
        <div class="atlas-navbar__loading__empty">
          {{ 'NOTIFICATIONS.NO_NOTIFICATIONS' | translate }}
        </div>
      }
      @if (notifications?.length > 0) {
        @if (settingsByNotification$ | async; as settings) {
          @for (notification of notifications; track notification; let last = $last) {
            <atlas-notification
              class="atlas-navbar__notification__item"
              [notification]="notification"
              [setting]="settings[notification.id]"
              [rollback]="getRollbackState(notification) | async"
              [showContext]="showContext"
              [last]="last"
              (onclick)="follow(notification)"
              (read)="setFollowed($event, true)"
              (unread)="setFollowed($event, false)"
              (subscribe)="updateSubscription(notification.id, settings[notification.id], SubscriptionState.Subscribe)"
              (unsubscribe)="
                updateSubscription(notification.id, settings[notification.id], SubscriptionState.Unsubscribe)
              "
              (undo)="undo(notification.id, settings[notification.id])"
            ></atlas-notification>
          }
          @if (hasMore()) {
            <div class="atlas-navbar__load-more">
              @if (canLoadMore()) {
                <button
                  mat-button
                  class="atlas-navbar__load-more-btn"
                  (click)="loadMoreNotifications()"
                  [disabled]="isLoadingMore()"
                  >
                  {{ isLoadingMore() ? 'Loading...' : 'Load More' }}
                </button>
              } @else {
                <div class="atlas-navbar__limit-reached">
                  <mat-icon>info</mat-icon>
                  <span>Displaying recent {{ MAX_NOTIFICATIONS }} notifications</span>
                </div>
              }
              <ng-template #limitReached>
                <div class="atlas-navbar__limit-reached">
                  <mat-icon>info</mat-icon>
                  <span>Displaying recent {{ MAX_NOTIFICATIONS }} notifications</span>
                </div>
              </ng-template>
            </div>
          }
        } @else {
          @if ((error$ | async) === true) {
            <div class="atlas-navbar__loading__empty">
              {{ 'NOTIFICATIONS.LOAD_FAILURE' | translate }}
            </div>
          }
          @if ((error$ | async) === false) {
            <div class="atlas-navbar__loading">
              <atlas-loader [size]="24"></atlas-loader>
            </div>
          }
        }
      }
    } @else {
      @if ((error$ | async) === true) {
        <div class="atlas-navbar__loading__empty">
          {{ 'NOTIFICATIONS.LOAD_FAILURE' | translate }}
        </div>
      }
      @if ((error$ | async) === false) {
        <div class="atlas-navbar__loading">
          <atlas-loader [size]="24"></atlas-loader>
        </div>
      }
    }
  </atlas-flyout>
</ng-template>

<ng-template #loading>
  @if ((error$ | async) === true) {
    <div class="atlas-navbar__loading__empty">
      {{ 'NOTIFICATIONS.LOAD_FAILURE' | translate }}
    </div>
  }
  @if ((error$ | async) === false) {
    <div class="atlas-navbar__loading">
      <atlas-loader [size]="24"></atlas-loader>
    </div>
  }
</ng-template>
